export const CREATE_EVENT = 'CREATE_EVENT';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const CREATE_EVENT_FAILED = 'CREATE_EVENT_FAILED';

export const UPDATE_EVENT = 'UPDATE_EVENT';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_FAILED = 'UPDATE_EVENT_FAILED';

export const GET_EVENTS = 'GET_EVENT';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAILED = 'GET_EVENTS_FAILED';
export const GET_PAST_EVENTS = 'GET_PAST_EVENTS';
export const GET_PAST_EVENTS_SUCCESS = 'GET_PAST_EVENTS_SUCCESS';
export const GET_PAST_EVENTS_FAILED = 'GET_PAST_EVENTS_FAILED';

export const SORT_EVENTS = 'SORT_EVENTS';

export const ON_CHANGE_TAB_EVENT = 'ON_CHANGE_TAB_EVENT';

export const GET_EVENT_BY_ID = 'GET_EVENT_BY_ID';
export const GET_EVENT_SUCCESS = 'GET_EVENT_SUCCESS';

export const CANCEL_EVENT = 'CANCEL_EVENT';
export const DISABLE_EVENT = 'DISABLE_EVENT';
export const CANCEL_EVENT_SUCCESS = 'CANCEL_EVENT_SUCCESS';
export const CANCEL_EVENT_FAILED = 'CANCEL_EVENT_FAILED';

export const GET_FILTERED_EVENTS = 'GET_FILTERED_EVENTS';
export const GET_FILTERED_EVENTS_SUCCESS = 'GET_FILTERED_EVENTS_SUCCESS';
export const GET_FILTERED_EVENTS_FAILED = 'GET_FILTERED_EVENTS_FAILED';

export const RESET_FILTERED_EVENTS = 'RESET_FILTERED_EVENTS';

export const RESET_UPDATE_EVENT_FORM = 'RESET_UPDATE_EVENT_FORM';

export const SET_EVENT = 'SET_EVENT';
export const SET_MANAGE_EVENT_TAB = 'SET_MANAGE_EVENT_TAB';

export const SEND_NOTIFICATION_SMS_TO_VENDORS = 'SEND_NOTIFICATION_SMS_TO_VENDORS';
export const SEND_NOTIFICATION_SMS_TO_VENDORS_SUCCESS = 'SEND_NOTIFICATION_SMS_TO_VENDORS_SUCCESS';
export const SEND_NOTIFICATION_SMS_TO_VENDORS_FAILED = 'SEND_NOTIFICATION_SMS_TO_VENDORS_FAILED';

export const GET_DIGITAL_MARKETING = 'GET_DIGITAL_MARKETING';
export const GET_DIGITAL_MARKETING_SUCCESS = 'GET_DIGITAL_MARKETING_SUCCESS';
export const GET_DIGITAL_MARKETING_FAILED = 'GET_DIGITAL_MARKETING_FAILED';

export const ON_DISPLAY_MODAL_SMS = 'ON_DISPLAY_MODAL_SMS';

export const CHANGE_LOADING = 'CHANGE_LOADING';
